import { getQuestions } from "../../api.services";
import { useState, useEffect } from "react";
import "../exam/exam.css";
import { useRef } from "react";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { examSubmit } from "../../results.service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faArrowLeft, faBell } from "@fortawesome/free-solid-svg-icons";
import SubmitConfirmationModal from "../modals/submit-confirmation";
import ExitModal from "../modals/exit-modal";
import { SpinnerDotted } from "spinners-react";

const BackButtonListener = ({ children }) => {
  // const [pressed, setPressed] = React.useState(false)
  React.useEffect(() => {
    window.onpopstate = () => {
      // setPressed(true)
      window.location.href = "/evaluacion/home";
    };
  });
  return <div></div>;
};

const minuteSeconds = 60;

const SCORE_CHECKPOINT = 80;

const timerProps = {
  isPlaying: true,
  size: 120,
  strokeWidth: 6,
};

function Exam() {
  //Register Form Info
  const { state } = useLocation();

  //Redirection method
  const navigate = useNavigate();

  //Check that the form info came correctly before displaying the exam
  if (!state?.name) {
    navigate("/evaluacion/home");
  }
  //Check that participant exists

  //Alert for Winners
  const WinnerAlert = ({ color }) => {
    const [showAlert, setShowAlert] = React.useState(true);
    return (
      <>
        {showAlert ? (
          <div
            className={
              "flex text-white px-6 py-4 border-0 rounded relative mb-4 bg-blue-500"
            }
          >
            <span className="text-xl inline-block mr-5 align-middle">
              <FontAwesomeIcon icon={faBell} />
            </span>
            <span className="inline-block align-middle mr-8">
              <b className="capitalize"> ¡Felicidades! </b> Por obtener
              calificaciones sobresalientes acabas de obtener un certificado al
              correo: <b className="text-blue-900">{state.email}</b>
            </span>
            <button
              className="absolute bg-transparent text-2xl font-semibold leading-none right-0 top-0 mt-4 mr-6 outline-none focus:outline-none w-min border-none hover:bg-transparent"
              onClick={() => setShowAlert(false)}
            >
              <span>×</span>
            </button>
          </div>
        ) : null}
      </>
    );
  };

  const scrollListener = useRef();
  const timerEvent = Event;
  const startTime = Date.now() / 1000; // use UNIX timestamp in seconds
  const endTime = startTime + 600; // use UNIX timestamp in seconds

  const [reachedBottom, setReachedBottom] = useState(false);

  const onScroll = (e) => {
    // console.log("e:",e)
    if (scrollListener.current) {
      const { scrollTop, scrollHeight, clientHeight } = scrollListener.current;

      if (scrollTop + clientHeight >= scrollHeight * 0.85) {
        if (!reachedBottom) {
          timerEvent = e;
          setReachedBottom(true);
        }
      } else {
        if (reachedBottom) {
          setReachedBottom(false);
        }
      }
    }
  };

  window.onbeforeunload = function (e) {
    localStorage.clear();
    clearAll();
    // console.log("-------------------SALIENDO")

    // window.location.reload(false);
    // window.location.href ='/home'
  };

  //Async-friendly variables
  const [puntuacion, setPuntuacion] = useState(0);
  const [isFetched, setIsFetched] = useState(false);
  const [isFinished, setIsFinished] = useState(false);
  const [tiempoRestante, setTiempoRestante] = useState(600);
  const [areDisabled, setAreDisabled] = useState(false);
  const [answersShown, setAnswersShown] = useState(false);
  const [eventos, setEventos] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [tempAnswers, setTempAnswers] = useState([]);
  const [resultsPosted, setResultsPosted] = useState(false);
  const [participant, setParticipant] = useState({});
  const [examResult, setExamResult] = useState({});

  const [timerHidden, setTimerHidden] = useState(true);
  const [clickedStyle, setClickedStyle] = useState("show-time");
  const [invalidExam, setInvalidExam] = useState(false);

  const [postCheck, setPostCheck] = useState(false);

  const [confirmed, setConfirmed] = useState(false);
  const [openSendModal, setOpenSendModal] = useState(false);
  const [closeSendModal, setCloseSendModal] = useState(false);
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [premio, setPremio] = useState(null);
  const [loadingQuestions, setLoadingQuestions] = useState(false);

  function clearAll() {
    setPuntuacion(0);
    setIsFetched(false);
    setTempAnswers([]);
    setQuestions([]);
  }

  //return home if navigate back

  //Get Method call to API (Exam questions + answers)
  if (!isFetched || invalidExam) {
    localStorage.clear();
    clearAll();
    setInvalidExam(false);

    if (questions.length === 0) {
      getQuestions().then((questionList) => {
        setQuestions(questionList);
      });
    }
    questions.forEach((q) => {
      if (q.opciones.length === 0 || !q.descripcion || !q || !q.opciones) {
        setInvalidExam(true);
      }
    });

    setIsFetched(true);
  }

  //Participants answers stored in local useState variable
  function storeAnswers(index, answer, e, answerNumber) {
    //Update already answered question option
    if (eventos[index - 1]) {
      updateSelection(eventos[index - 1], e);
    }
    //Set unanswered questions's answer
    else {
      updateSelection(null, e);
    }

    //Question Key for localStorage + tempAnswers (answers selected)
    let questionString = "pregunta" + index;

    let storeObj = {
      id: questionString,
      result: answer,
      index: answerNumber,
    };
    // answers[questionString].respuesta = []
    localStorage.setItem(questionString, answer);

    //Update question + answer object
    if (tempAnswers.length > 0) {
      let found = false;
      tempAnswers.forEach((temp) => {
        //update already answered question object
        if (temp.id === questionString) {
          temp.result = answer;
          temp.index = answerNumber;
          found = true;
        }
      });
      //store new answered question object
      if (!found) {
        tempAnswers.push(storeObj);
      }
    }
    //First answered question object
    else {
      tempAnswers.push(storeObj);
    }

    //Store HTML Event (Button) of the answer
    eventos[index - 1] = e;
    // console.log("ANSWER EVENTS: ",eventos)

    //This is to check answers live while testing
    console.log("Pregunta", index, ":", tempAnswers[index - 1]);
  }

  //Live/Async logic (timer + POST req)
  useEffect(() => {
    //Redirect to home on reload/refresh
    if (window.performance.navigation.type == 1) {
      window.location.href = "/evaluacion/home";
    }

    //Change timer's time live
    const intervalo = setInterval(() => {
      if (tiempoRestante > 0) setTiempoRestante((prev) => prev - 1);
      if (tiempoRestante === 0) {
        setAreDisabled(true);
        confirmSubmition();
        timerProps.isPlaying = false;
      }
    }, 1000);

    return () => clearInterval(intervalo);
  }, [tiempoRestante]);

  useEffect(() => {
    //Redirect to home on reload/refresh
    //SEND POST REQUEST (EXAM OBJ AND CERTIFICATE MAILING)
    if (resultsPosted) {
      examSubmit(participant, examResult).then((value) => {
        console.log("");
        setResultsPosted(false);
        window.scrollTo(0, 0);
        setParticipant({});
      });

      // POST/UPDATE Participant
    }
  }, [postCheck]);

  //Change answer button class after selection (make it marked or unmarked)
  function updateSelection(prevEv, newEv) {
    prevEv?.target.classList.remove("correct");
    newEv.target.classList.add("correct");
  }

  function updateTimer(Ev) {
    // console.log("clicked:",clickedStyle)
    setTimerHidden(!timerHidden);
    if (!timerHidden) {
      setClickedStyle("show-time");
    } else {
      setClickedStyle("hidden-timer");
    }
  }

  const backHome = (e) => {
    e.preventDefault();
    // console.log("TOUCHED");
    window.location.href = "/evaluacion/home";
    navigate("/evaluacion/home", { replace: true });
  };

  //Results View
  if (answersShown || tiempoRestante === 0) {
    let score = 0;
    let results = [];
    let questionNumber = 0;
    let ansArray = [];

    //Question Boxes
    questions.forEach((pregunta) => {
      questionNumber++;

      let questionKey = "pregunta" + questionNumber;

      let tempAnsObj = {};

      if (localStorage.getItem(questionKey)) {
        if (localStorage.getItem(questionKey) === "true") {
          pregunta.opciones.forEach((opcion) => {
            tempAnsObj = {
              questionId: opcion.questionId,
              value: opcion.isCorrect,
              answerId: opcion?.answerId,
            };
            ansArray.push(tempAnsObj);
            if (opcion.isCorrect) {
              score += 5;
              opcion.classString = "show-check correct-bg-answer";
            } else {
              opcion.classString = "disabled";
            }
          });
        } else if (localStorage.getItem(questionKey) === "false") {
          let optionID = 0;
          pregunta.opciones.forEach((opcion) => {
            if (opcion.isCorrect) {
              opcion.classString = "green-bg-answer";
            } else {
              tempAnswers.forEach((ans) => {
                // console.log("Check X mark #1: (ANS)",ans)
                // console.log("Check X mark #1: (OPCION)",opcion)
                // console.log("Check X mark #1: (OPCIONES)",pregunta)

                //Set new state variable to hold answer objs

                if (questionKey === ans.id) {
                  tempAnsObj.questionId = opcion.questionId;
                  tempAnsObj.value = opcion.isCorrect;

                  if (ans.index === undefined) {
                    opcion.classString = "show-x";
                  } else if (optionID === ans.index) {
                    tempAnsObj.answerId = opcion.answerId;
                    opcion.classString = "show-x";
                  }
                  ansArray.push(tempAnsObj);
                }
              });
              if (opcion.classString === undefined) {
                opcion.classString = "disabled";
              }
            }

            optionID++;
          });
        } else {
          pregunta.opciones.forEach((opcion) => {
            opcion.classString = "disabled";
          });
        }
      } else {
        pregunta.opciones.forEach((opcion) => {
          opcion.classString = "disabled";
        });
      }
    });

    //Kill Timer
    timerProps.isPlaying = false;

    //Notification for Winners
    //Certificate Validation
    if (score >= SCORE_CHECKPOINT) {
      results.push(
        <div className="spacing-height">
          {/* <span className="p-2">
                     ¡Felicidades! Calificaste para la rifa de SPN en el evento CIGEH - ADOARH 2022, revise el correo <b className="text-blue-900">{state.email} </b>
                      para más instrucciones.
                   </span> */}

          <WinnerAlert color={"blue"} />

          {/* <div className="spacing-height"></div> */}
        </div>
      );
    }

    //Back button
    results.push(
      <div className="grid col-start-1">
        <div
          className="bg-black rounded-xl m-4 p-4 justify-left w-min flex cursor-pointer hover:bg-gray-700 "
          onClick={backHome}
        >
          <FontAwesomeIcon icon={faHome} />
          <FontAwesomeIcon icon={faArrowLeft} className="ml-2 " />
        </div>
      </div>
    );

    //Scoreboard
    results.push(
      <div className="spacing-height lg:mr-20">
        <span className="text-2xl lg:ml-20">
          Resultados de{" "}
          <em>
            {state.name} {state.lastName}
          </em>
        </span>

        <div className="spacing-height results-card lg:pl-20">
          <span className="text-xl lg:mt-0">
            {/* Calificación
          <br />
          <span className="font-bold text-3xl"> {score} </span>/ 100 */}

            <a
              href=""
              class="disabled-link flex flex-col justify-between p-8 transition-shadow bg-white rounded-3xl shadow-xl group hover:shadow-lg w-60 h-50"
            >
              <div>
                <h5 class="text-5xl font-bold text-indigo-600">
                  {score} <p className="text-[22px]">/100</p>{" "}
                </h5>
                <div class="pt-2 mt-4 border-t-2 border-indigo-100">
                  <p class="text-sm font-medium tracking-widest text-gray-500 uppercase">
                    Calificación
                  </p>
                </div>
              </div>
            </a>
          </span>

          <br />
          {/* <span className="text-xl lg:mr-20 lg:ml-20 lg:mt-0 mt-6">
          Respuestas Correctas
          <br />
          <span className="font-bold text-3xl text-[#008000]"> {score/5} </span>
        </span> */}

          <a
            href=""
            class="disabled-link lg:mr-10 lg:ml-10 flex flex-col justify-between p-8 transition-shadow bg-white rounded-3xl shadow-xl group hover:shadow-lg w-60 h-50"
          >
            <div>
              <h5 class="text-5xl font-bold text-[#008000]">{score / 5}</h5>
              <div class="pt-2 mt-4 border-t-2 border-indigo-100">
                <p class="text-sm font-medium tracking-widest text-gray-500 uppercase">
                  Correctas
                </p>
              </div>
            </div>
          </a>

          <br />
          {/* <span className="text-xl lg:mt-0 mt-3">
          Respuestas Incorrectas
          <br />
          <span className="font-bold text-3xl text-red-700"> {20 - (score/5)} </span>
        </span> */}

          <a
            href=""
            class="disabled-link flex flex-col justify-between p-8 transition-shadow bg-white rounded-3xl shadow-xl group hover:shadow-lg w-60 h-50"
          >
            <div>
              <h5 class="text-5xl font-bold text-red-700">{20 - score / 5}</h5>
              <div class="pt-2 mt-4 border-t-2 border-indigo-100">
                <p class="text-sm font-medium tracking-widest text-gray-500 uppercase">
                  Incorrectas
                </p>
              </div>
            </div>
          </a>
        </div>

        <div className="spacing-height"></div>
      </div>
    );

    //  if(score>=SCORE_CHECKPOINT){

    //   results.push(
    //     <div className="spacing-height">
    //       <span className="p-4">
    //            Por obtener calificaciones sobresalientes acabas de obtener un certificado al correo: <b className="text-blue-900">{state.email}</b>
    //          </span>
    //          <div className="spacing-height"></div>
    //     </div>
    //     )
    //  }

    //Setting Letter Grade
    let letter;

    if (score >= 80 && score < 85) {
      letter = "B";
    } else if (score >= 85 && score < 90) {
      letter = "B+";
    } else if (score >= 90 && score < 95) {
      letter = "A";
    } else if (score >= 96) {
      letter = "A+";
    }

    //Setting States for Single POST Request
    if (!resultsPosted) {
      //  console.log("STATE",state)

      setParticipant(state);

      //SET STATE FOR RAFFLE POST
      setExamResult({
        grade: score,
        correctCount: score / 5,
        incorrectCount: (100 - score) / 5,
        letter: letter,
        answers: ansArray,
      });
      setResultsPosted(true);
    }

    //Results per Question
    questions.forEach((pregunta) => {
      results.push(
        <main className="app">
          <div className="lado-derecho">
            <div className="numero-pregunta">
              <span>
                {" "}
                Pregunta <b>{pregunta.id}</b> de
              </span>{" "}
              <b>20</b>
            </div>
            <div className="pregunta-box">
              <div className="titulo-pregunta">{pregunta.titulo}</div>
            </div>

            <div className="answer-text lg:grid lg:grid-cols-2 gap-4">
              {pregunta?.opciones?.map((respuesta) => (
                <div className={respuesta.classString}>
                  <button
                    disabled={true}
                    key={respuesta.textoRespuesta}
                    // onClick={(e) => saveAnswer(pregunta.id, respuesta.isCorrect,e)}
                    className="lg:mt-0 mt-5"
                  >
                    {respuesta.textoRespuesta}
                  </button>

                  <svg
                    className="check hidden-check"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                  >
                    <path d="M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM371.8 211.8C382.7 200.9 382.7 183.1 371.8 172.2C360.9 161.3 343.1 161.3 332.2 172.2L224 280.4L179.8 236.2C168.9 225.3 151.1 225.3 140.2 236.2C129.3 247.1 129.3 264.9 140.2 275.8L204.2 339.8C215.1 350.7 232.9 350.7 243.8 339.8L371.8 211.8z" />
                  </svg>

                  <svg
                    className="xmark hidden-xmark"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                  >
                    <path d="M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM175 208.1L222.1 255.1L175 303C165.7 312.4 165.7 327.6 175 336.1C184.4 346.3 199.6 346.3 208.1 336.1L255.1 289.9L303 336.1C312.4 346.3 327.6 346.3 336.1 336.1C346.3 327.6 346.3 312.4 336.1 303L289.9 255.1L336.1 208.1C346.3 199.6 346.3 184.4 336.1 175C327.6 165.7 312.4 165.7 303 175L255.1 222.1L208.1 175C199.6 165.7 184.4 165.7 175 175C165.7 184.4 165.7 199.6 175 208.1V208.1z" />
                  </svg>
                </div>
              ))}
            </div>
          </div>
          <BackButtonListener />
        </main>
      );
    });

    //Exit Button
    results.push(
      <div className="timer">
        {/* <div className="text"> Tiempo restante: </div> */}
        <div className="finish-buttons-container">
          <button
            className="exit-button"
            onClick={() => {
              navigate("/evaluacion/home");
              window.location.href = "/evaluacion/home";
              setIsFetched(false);
              state = {};
              clearAll();
            }}
          >
            Salir
          </button>
        </div>
      </div>
    );

    return results;
  }

  function confirmSubmition() {
    setTiempoRestante(0);
    setPostCheck(true);
    setAnswersShown(true);
    timerProps.isPlaying = false;
  }

  function exitExam() {
    window.location.href = "/evaluacion/home";
    navigate("/evaluacion/home");
    setIsFetched(false);
    state = {};
  }
  //** MAIN EXAM SETUP */

  //Array to return Exam View
  let exam = [];

  if (openSendModal) {
    const send = () => confirmSubmition();
    exam.push(
      <SubmitConfirmationModal
        openSendModal={setOpenSendModal}
        submitExam={setConfirmed}
        send={send}
      />
    );
  }
  if (openCancelModal) {
    const exit = () => exitExam();
    exam.push(<ExitModal openExitModal={setOpenCancelModal} exit={exit} />);
  }

  // console.log("MODAL = ",openSendModal)
  //Time inside Timer

  var minutes = Math.floor(tiempoRestante / 60);
  var seconds = tiempoRestante - minutes * 60;

  //segundos con decimales para la animacion
  const secondsAnimation = tiempoRestante % 60;

  if (seconds < 10) {
    seconds = `0` + seconds;
  }

  //TIMER COMPONENTS
  exam.push(
    <SpinnerDotted
      className="m-10"
      size={50}
      enabled={!isFetched}
      color={"#643A90"}
    />
  );

  if (isFetched) {
    exam.push(
      <div className={`timers-circles ${clickedStyle} sticky-style`}>
        <span className="font-bold text-lg">Tiempo Restante</span>
        <span className="xl:hidden mr-[0.25rem]">=</span>

        <div
          className={` ${clickedStyle}`}
          onScroll={(e) => onScroll(e)}
          ref={scrollListener}
        >
          <div className="flex xl:mt-5">
            <CountdownCircleTimer
              {...timerProps}
              colors={["#061a40", "#B900E2", "#003559", "#003559"]}
              colorsTime={[6, 3, 1, 0]}
              duration={600}
              initialRemainingTime={seconds}
            >
              {({ elapsedTime, color }) => (
                <span style={{ color }}>
                  <div className="time">{minutes}</div>
                  minutos
                </span>
              )}
            </CountdownCircleTimer>
            <div className="spacing"></div>
            <CountdownCircleTimer
              {...timerProps}
              colors={["#061a40", "#B900E2", "#003559", "#003559"]}
              colorsTime={[45, 30, 15, 0]}
              duration={minuteSeconds}
              initialRemainingTime={minuteSeconds}
              onComplete={(totalElapsedTime) => ({
                shouldRepeat: minutes > 0,
                delay: 0.8,
              })}
            >
              {({ elapsedTime, color }) => (
                <span style={{ color }}>
                  <div className="time">{seconds}</div>
                  segundos
                </span>
              )}
            </CountdownCircleTimer>
          </div>
        </div>
      </div>
    );
  }
  //Mobile minimize timer
  exam.push(
    <button
      className="2xl:hidden lg:mt-[-6rem] lg:mr-[2rem] rounded-full [#4A0094] hover:[#4A0094] bg-[#4A0094] hover:bg-[#4A0094] w-[55px] h-[55px] timer-minimizer"
      onClick={(e) => updateTimer(timerEvent)}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-16 w-16"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    </button>
  );

  exam.push(<div className="mt-[10.5rem]"></div>);

  //QUESTIONS BOXES
  questions.forEach((pregunta) => {
    exam.push(
      <main className="app t-3">
        <div className="lado-derecho">
          <div className="numero-pregunta">
            <span>
              {" "}
              Pregunta <b>{pregunta.id}</b> de
            </span>{" "}
            <b>20</b>
          </div>
          <div className="pregunta-box">
            <div
              className="titulo-pregunta"
              onCopy={(e) => {
                e.preventDefault();
                return false;
              }}
            >
              {pregunta.titulo}
            </div>
          </div>

          <div className="answer-text lg:grid lg:grid-cols-2 lg:gap-4 ">
            {pregunta?.opciones?.map((respuesta) => (
              <div className="box">
                <button
                  className="mobile-exam"
                  disabled={areDisabled}
                  key={respuesta.textoRespuesta}
                  // onClick={(e) => saveAnswer(pregunta.id, respuesta.isCorrect,e)}
                  onClick={(e) =>
                    storeAnswers(
                      pregunta.id,
                      respuesta.isCorrect,
                      e,
                      respuesta.questionIndex
                    )
                  }
                  onCopy={(e) => {
                    e.preventDefault();
                    return false;
                  }}
                >
                  {respuesta.textoRespuesta}
                </button>
              </div>
            ))}
          </div>
        </div>
        <BackButtonListener />
      </main>
    );
  });

  // exam.push(<SubmitConfirmationModal confirmSubmit={confirmSubmition()
  // }/>)

  //BUTTONS
  exam.push(
    <div className="timer">
      {/* <div className="text"> Tiempo restante: </div> */}
      <div className="finish-buttons-container">
        <button
          className="finish"
          onClick={() => {
            // setTiempoRestante(0);
            // setPostCheck(true)
            // setAnswersShown(true);
            // timerProps.isPlaying = false;
            setOpenSendModal(true);
            // confirmSubmition()
          }}
        >
          Entregar
        </button>
        <button
          className="finish-cancel"
          onClick={() => {
            // window.location.href = '/evaluacion/home'
            // navigate('/evaluacion/home');
            // setIsFetched(false)
            // state = {}
            setOpenCancelModal(true);
          }}
        >
          Cancelar
        </button>
      </div>
    </div>
  );

  return exam;
}

export default Exam;
